<template>
  <div id="app" :class="{mobileType:screenWidth<992,pcType:screenWidth>=992,'ar-style':LANGUAGE == 'ar'}">
    <router-view :screenWidth="screenWidth" v-if="isRouterAlive"/>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

// 自动获取1iframe高度
const setIframeHeight = (iframe)=>{
  iframe = document.getElementById('external-frame');
  try{
    if (iframe) {
    var iframeWin = iframe.contentWindow || iframe.contentDocument.parentWindow;
    if (iframeWin.document.body) { 
      iframe.height = iframeWin.document.body.scrollHeight || iframeWin.document.documentElement.scrollHeight || 600;
    }else{
      iframe.height = 600;
    }
    // var bHeight = iframe.contentWindow.document.body.scrollHeight;
    // var dHeight = iframe.contentWindow.document.documentElement.scrollHeight;
    // iframe.height = Math.max(bHeight, dHeight);
    return iframe.height;
  }
  }catch(err){
    iframe.height = 600;
    return iframe.height;
  }
};
export default {
  name: "App",
  provide(){
    return{
      reload:this.reload,
      setIframeHeight:setIframeHeight
    }
  },
  metaInfo(){
    return{
      title: this.title,
      meta: [
        { name: 'Description', content:this.description }
      ]
    }
  },
  data() {
    return {
      title: '',
      description: '',
      isRouterAlive:true,
      screenWidth: document.body.clientWidth // 这里是给到了一个默认值 （这个很重要）
    };
  },
  created(){
    this.changeMetaInfo();
  },
  computed:{
    ...mapState(["LANGUAGE"]),
  },
  mounted() {
    this.SAVELANGUAGE(localStorage.language || "en");
    var that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
        setIframeHeight()
      })();
    };

    // 判断页面是刷新还是关闭，页面关闭时，localstorage设置为默认的'en'
    window.onload = function(){
      if(navigator.userAgent.toLocaleLowerCase().indexOf('firefox') > -1){
        localStorage.language = 'en'
      }
      if(!localStorage["tempFlag"]){
        localStorage.language = 'en'
        location.reload();   //不能省，强制跳到登陆页
      }else{
        localStorage["tempFlag"] = false;
      }
    }
    // firefox不识别onunload和onbeforeunload，所以在onload识别是不是火狐
    window.onunload = function (){
      localStorage["tempFlag"] = true;
    }
    window.onbeforeunload = function (){
      localStorage["tempFlag"] = true;
    }
  },
  watch: {
    screenWidth(val) {
      if (!this.timer) {
        this.screenWidth = val;
        this.timer = true;
        let that = this;
        setTimeout(function() {
          // that.screenWidth = that.$store.state.canvasWidth
          that.timer = false;
        }, 400);
      }
    }
  },
  methods: {
    ...mapMutations(["SAVELANGUAGE"]),
    reload(){
      this.changeMetaInfo();
      this.isRouterAlive = false;
      this.$nextTick(()=>{
        this.isRouterAlive = true;
      })
    },
    changeMetaInfo(){
      this.title = this.$t('headTtitle');
      this.description = this.$t('headDescription');
    },
  }
};
</script>

<style lang="scss">
body{
  margin: 0;
  display: flex;
}
#app {
  position: static;
  width: 100%;
  ul {
    list-style: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue